import { createRouter, createWebHistory } from "vue-router";
import { ReviseMeta } from "@/util/meta";
import { deviceType } from "@/util/base";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      component: () => import("./views/gw/index.vue"),
    },
    {
      path: "/m",
      component: () => import("./views/gw/index.vue"),
    },
    // 预约
    {
      path: "/pre",
      component: () => import("./views/yy/index.vue"),
    },
    // 预约
    {
      path: "/pre/m",
      component: () => import("./views/yy/index.vue"),
    },
    // 预约
    {
      path: "/pre/FB",
      component: () => import("./views/yy/index.vue"),
    },
    // 预约
    {
      path: "/pre/FB/m",
      component: () => import("./views/yy/index.vue"),
    },
    // 预约
    {
      path: "/pre/GG",
      component: () => import("./views/yy/index.vue"),
    },
    // 预约
    {
      path: "/pre//GG/m",
      component: () => import("./views/yy/index.vue"),
    },
    // 预约
    {
      path: "/pre/TT",
      component: () => import("./views/yy/index.vue"),
    },
    // 预约
    {
      path: "/pre/TT/m",
      component: () => import("./views/yy/index.vue"),
    },
    // 单手杀
    {
      path: "/game/:type(m)?",
      component: () => import("./views/game/index.vue"),
    },
    // 寻宝页
    {
      path: "/treasure",
      component: () => import("./views/treasure/index.vue"),
    },
    {
      path: "/treasure/m",
      component: () => import("./views/treasure/index.vue"),
    },
    {
      path: "/down/:version",
      component: () => import("./views/down/index.vue"),
      meta: {
        title:
          "MapleStory R-Evolution is now open for pre-registration! Nexon’s Latest Licensed Game!",
        description:
          "NEXON-licensed mobile RPG MapleStory R-Evolution is open for pre-registration! Sign up to claim limited-edition outfits, SSR pets, and other exclusive rewards!",
      },
    },
    // 404
    {
      path: "/:pathMatch(.*)*",
      component: () => import("../../components/404.vue"),
    },
  ],
});

router.beforeEach((to, from, next) => {
  ReviseMeta(to.meta.title, to.meta.keywords, to.meta.description);

  const specialPages = [
    /^\/down(\/.*)?$/,
    /^\/shop(\/.*)?$/,
    /^\/resume(\/.*)?$/,
  ];
  const isSpecialPage = specialPages.some((pattern) => pattern.test(to.path));

  if (isSpecialPage) {
    next();
    return;
  }

  const isWap = deviceType() == "wap";
  const pcPath = to.path.replace(/\/m$/, "");
  const wapPath = pcPath.endsWith("/") ? `${pcPath}m` : `${pcPath}/m`;

  if (isWap && !to.path.endsWith("/m")) {
    next({ path: wapPath, query: to.query });
  } else if (!isWap && to.path.endsWith("/m")) {
    next({ path: pcPath, query: to.query });
  } else {
    next();
  }
});

export default router;
